module.exports = __webpack_public_path__ + "static/media/upload.da5f5902.svg";